<template>
  <div class="pipeline-cursor" id="pipeline-cursor">
    <div class="pipeline-cursor-div">
        <div class="pipeline-cursor-title">
          <i class="iconfont">&#xe69e;</i>{{pplItem.title}}
        </div>
        <div class="pipeline-cursor-more" @click="all_modal = true">查看全部管线<i class="iconfont">&#xe72c;</i></div>
    </div>
    <div class="pipeline-cursor-summary" v-html="pplItem.summary"></div>
    <div class="pipeline-cursor-content">
      <!-- <div class="pipeline-cursor-filter">
        <div :class="'upload-img ' + 'upload-img-' + !upload_loading" @click="uploadImg">
          <div v-if="upload_loading" class="upload-loading">
            <Icon type="ios-loading" size=15 class="demo-spin-icon-load"></Icon>正在生成
          </div>
          <div v-else>导出图片</div>
        </div>
      </div> -->
      <div class="pipeline-cursor-div" :id="'cursor-div-' + pplItem.id" @click="all_modal = true">
        <PipelineNodes :getImageBlob="getImageBlob" :pplItem="pplItem" :params="params" :pplType="pplType" :nodeFormId="nodeFormId" @haddleMoreNewTopic="haddleMoreNewTopic"></PipelineNodes>
      </div>
    </div>
    <div class="tip-content">
      <p class="tip">数据来源：<template v-if="pplItem.src_name">{{pplItem.src_name}}</template><template v-else>动脉橙产业智库</template></p>
      <div class="pipeline-cursor-more" @click="all_modal = true">查看全部管线<i class="iconfont">&#xe72c;</i></div>
    </div>
    <div class="upload-div">
      <div :id="'pip-table-' + pplItem.id">
        <div class="pipeline-cursor-title">
          <i class="iconfont">&#xe69e;</i>{{pplItem.title}}
        </div>
        <div class="pipeline-cursor-summary" v-html="pplItem.summary"></div>
        <img :src="!theme_switch ? logo_whrite : logo_path">
        <PipelineNodes :getImageBlob="getImageBlob" :pplItem="pplItem" :params="params" :pplType="pplType"></PipelineNodes>
      </div>
    </div>
    <Modal v-model="detail_modal" class="detail-modal" width="500">
      <div slot="header">
        <template v-if="ppl_item.news_topic">{{ppl_item['type_id'] | dealName(pplType, 'id', 'name')}}(共{{ppl_item.news_topic.length}}条)</template>
      </div>
      <div class="list">
        <div v-for="item,index in ppl_item.news_topic" :key="index">
          <i class="iconfont">&#xe62b;</i>
          <div class="li-top" @click="goTopicDetail(item.uid)">
            <span>{{item.title}}</span>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button @click="detail_modal = !detail_modal">知道了</Button>
      </div>
    </Modal>
    <Modal v-model="all_modal" class="all-modal" width="auto" footer-hide>
      <div slot="header">
        <template>
          <div class="pipeline-cursor-content">
            <div class="pipeline-cursor-filter">
              <div class="filter-left">
                <Dropdown @on-click="haddleScreenDropdown($event, 'node_form_id')" v-if="node_form_list.length>1">
                  <div class="btn">
                    <span>{{params.node_form_id | dealName(node_form_list, 'node_form_id', 'name')}}</span>
                    <Icon type="md-arrow-dropdown" />
                  </div>
                  <DropdownMenu slot="list">
                    <DropdownItem v-for="item,index in node_form_list" :key="index" :name="item.node_form_id" :selected="params.node_form_id == item.node_form_id">{{item.name}}</DropdownItem>
                  </DropdownMenu>
                </Dropdown>

                <Dropdown @on-click="haddleScreenDropdown($event, 'entity_uid')">
                  <div class="btn">
                    <span v-if="!params.entity_uid">按公司筛选</span>
                    <span v-else>{{params.entity_uid | dealName(company_list, 'entity_uid', 'short_name')}}</span>
                    <Icon type="md-arrow-dropdown" />
                  </div>
                  <DropdownMenu slot="list">
                    <DropdownItem name="" :selected="params.entity_uid == ''">全部</DropdownItem>
                    <DropdownItem v-for="item,index in company_list" :key="index" :name="item.entity_uid" :selected="params.entity_uid == item.entity_uid">{{item.short_name}}</DropdownItem>
                  </DropdownMenu>
                </Dropdown>

                <Dropdown @on-click="haddleScreenDropdown($event, 'technology')" v-show="params.node_form_id != '2'">
                  <div class="btn">
                    <span>{{params.technology || '按技术筛选'}}</span>
                    <Icon type="md-arrow-dropdown" />
                  </div>
                  <DropdownMenu slot="list">
                    <DropdownItem name="" :selected="params.technology == ''">全部</DropdownItem>
                    <DropdownItem v-for="item,index in technology_list" :key="index" :name="item" :selected="params.technology == item">{{item}}</DropdownItem>
                  </DropdownMenu>
                </Dropdown>

                <Dropdown @on-click="haddleScreenDropdown($event, 'target')" v-show="params.node_form_id != '2'">
                  <div class="btn">
                    <span v-if="!params.target">按靶点筛选</span>
                    <span v-else>{{params.target | dealName(target_list, 'id', 'short_name')}}</span>
                    <Icon type="md-arrow-dropdown" />
                  </div>
                  <DropdownMenu slot="list">
                    <DropdownItem name="" :selected="params.target == ''">全部</DropdownItem>
                    <DropdownItem v-for="item,index in target_list" :key="index" :name="item.id" :selected="params.target == item.id">{{item.short_name}}</DropdownItem>
                  </DropdownMenu>
                </Dropdown>

                <Dropdown @on-click="haddleScreenDropdown($event, 'indication')">
                  <div class="btn">
                    <span>{{params.indication || '按适应症筛选'}}</span>
                    <Icon type="md-arrow-dropdown" />
                  </div>
                  <DropdownMenu slot="list">
                    <DropdownItem name="" :selected="params.indication == ''">全部</DropdownItem>
                    <DropdownItem v-for="item,index in indication_list" :key="index" :name="item" :selected="params.indication == item">{{item}}</DropdownItem>
                  </DropdownMenu>
                </Dropdown>

                <Dropdown @on-click="haddleScreenDropdown($event, 'node_id')">
                  <div class="btn">
                    <span v-if="!params.node_id">按阶段筛选</span>
                    <span v-else>{{params.node_id | dealName(pplTyped, 'id', 'name')}}</span>
                    <Icon type="md-arrow-dropdown" />
                  </div>
                  <DropdownMenu slot="list">
                    <DropdownItem name="" :selected="params.node_id == ''">全部</DropdownItem>
                    <DropdownItem v-for="item,index in pplTyped" :key="index" :name="item.id" :selected="params.node_id == item.id">{{item.name}}</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div> 
            </div>
          </div>
        </template>
      </div>
      <div class="pipeline-content">
        <div class="pipeline-cursor-content pipeline-cursor-content-right">
            <div class="pipeline-cursor-div" :id="'cursor-div-header' + pplItem.id" style="width: auto; max-width: calc(100% - 4px);overflow:hidden ">
              <div>
                <table class="top-header" :style="{'background-image': 'url(' + watermark +')', 'width': ((params.node_form_id != '2' ? 468 : 280) + pplTyped.length*100) + 'px'}">
                  <thead>
                    <tr>
                      <td class="left-th" width="106">所属公司</td>
                      <td class="left-th" width="86">产品名称</td>
                      <td class="left-th" width="86" v-show="params.node_form_id != '2'">技术</td>
                      <td class="left-th" width="102" v-show="params.node_form_id != '2'">靶点</td>
                      <td class="left-th" width="86">适应症</td>
                      <!-- <td class="left-th" width="86" v-show="params.node_form_id != '2'">权利区域</td>
                      <td class="left-th" width="86" v-show="params.node_form_id != '2'">来源</td> -->
                      <td class="right-th" width="100" v-for="type in pplTyped" :key="type.id">{{type.name}}</td>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
            <div class="pipeline-cursor-div" :id="'cursor-div-modal' + pplItem.id" style="width: auto; max-width: 100%;max-height:calc(80vh - 160px)">
              <PipelineNodes :pplItem="pplItem" :getImageBlob="getImageBlob" :isAll="isAll" :params="params" :pplType="pplType" @haddleMoreNewTopic="haddleMoreNewTopic"></PipelineNodes>
            </div>
          </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import PipelineNodes from "./PipelineNodes";
import html2canvas from 'html2canvas'
export default {
  props: ['pplItem', 'paramsUid', 'pplType', 'pplNodeForm'],
  components: {
    PipelineNodes
  },
  computed: {
    watermark() {
      return !this.$store.state.theme_switch ? this.watermark_white : this.watermark_gray
    },
    theme_switch() {
      return this.$store.state.theme_switch;
    },
    static_img_url() {
      return this.$store.state.static_img_url;
    },
    node_form_list() {
      let arr = []
      this.pplItem.content.map(item => {
        if (arr.findIndex(a => item.node_form_id == a.node_form_id) == -1) {
          arr.push({ 
            'name': this.pplNodeForm.find(e => e.id == item.node_form_id).name, 
            'node_form_id': item.node_form_id 
          })
        }
      })
      return arr
    },
    company_list() {
      let arr = []
      this.pplItem.content.map(item => {
        if (item.node_form_id == this.params.node_form_id && arr.findIndex(a => item.entity_uid == a.entity_uid) == -1) {
          arr.push({ 'short_name': item.short_name, 'entity_uid': item.entity_uid })
        }
      })
      return arr
    },
    technology_list() {
      let arr = []
      this.pplItem.content.map(item => {
        item.technology.map(item2 => {
          if (arr.findIndex(a => item2 == a) == -1) {
            arr.push(item2)
          }
        })
      })
      return arr
    },
    target_list() {
      let arr = []
      this.pplItem.content.map(item => {
        item.target.map(item2 => {
          if (arr.findIndex(a => item2.id == a.id) == -1) {
            arr.push(item2)
          }
        })
      })
      return arr
    },
    indication_list() {
      let arr = []
      this.pplItem.content.map(item => {
        if(item.node_form_id == this.params.node_form_id){
          item.indication.map(item2 => {
            if (arr.findIndex(a => item2 == a) == -1) {
              arr.push(item2)
            }
          })
        }
      })
      return arr
    },
  },
  data() {
    return {
      upload_loading: false,
      params: {
        entity_uid: '',
        technology: '',
        target: '',
        indication: '',
        node_form_id: '',
        node_id: ''
      },
      detail_modal: false,
      ppl_item: {},
      domObj: null,
      domObjmodal: null,
      domObjheader: null,
      logo_whrite: '',
      logo_path: '',
      all_modal: false,
      isAll: true,
      pplTyped: [],
      nodeFormId: '1',
    }
  },
  watch:{
    'params.node_form_id'(val){
      if(val){
        this.pplTyped = this.pplType.filter(e =>e.pipeline_node_form_id == this.params.node_form_id)
      }
    }
  },
  methods: {
    haddleScreenDropdown(name, keyword) {
      if(keyword == 'node_form_id') {
        for(let key in this.params){
          this.params[key] = ''
        }
      }
      this.params[keyword] = name
    },
    getImageBlob(url, cb) {
      var xhr = new XMLHttpRequest();
      xhr.open('get', url, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        let img_url = null
        if (this.status == 200) {
          // console.log(URL.createObjectURL(this.response))
          img_url = URL.createObjectURL(this.response)
        }
        if (cb) cb(img_url)
      };
      xhr.send();
    },
    uploadImg() {
      let scroll_top = document.documentElement.scrollTop || document.body.scrollTop

      if (!this.upload_loading) {
        this.upload_loading = true
        let upload_dom = document.getElementById('pip-table-' + this.pplItem.id)
        let _this = this
        html2canvas(upload_dom, { 
          height: upload_dom.offsetHeight, // 下面解决当页面滚动之后生成图片出现白边问题
          width: upload_dom.offsetWidth,
          scrollY: -window.pageYOffset,
          useCORS: true,
          }).then((canvas) => {
          let a = document.createElement('a')
          document.body.appendChild(a)
          a.href = canvas.toDataURL("image/png")
          a.download = _this.pplItem.title
          a.click()
          _this.upload_loading = false
        })
      } else {
        this.$Message.error('请勿重复操作！');
      }
    },
    haddleMoreNewTopic(item) {
      this.ppl_item = { ...item }
      this.detail_modal = true
    },
    goTopicDetail(uid) {
      const href = this.$store.state.index2_path + '/newsDetail/' + uid
      window.open(href, "_blank");
    },
    scrollFunction(type) {
      let dom_id = 'cursor-div-' + type + this.pplItem.id
      this['domObj' + type] = document.getElementById(dom_id) // 通过id获取要设置的div
      
      if(!type){
        if (this['domObj' + type].attachEvent) { // IE
          this['domObj' + type].attachEvent('onmousewheel', (e=Event)=>{
              this.mouseScroll(e, type)
            }
          )
        } else if (this['domObj' + type].addEventListener) {
          this['domObj' + type].addEventListener('DOMMouseScroll', (e=Event)=>{
            this.mouseScroll(e, type)
          }, false)
        }
        this['domObj' + type].onmousewheel = this['domObj' + type].onmousewheel = (e=Event)=>{
          this.mouseScroll(e, type)
        }
      }
      
      this['domObj' + type].addEventListener('scroll', (e=Event)=>{
        if(type == 'modal'){ //移动表头
          this.domObjheader = document.getElementById('cursor-div-header' + this.pplItem.id)
          this.domObjheader.scrollLeft = this['domObj' + type].scrollLeft
        }
      }, true)
    },
    mouseScroll(event, type) { // google 浏览器下
      let detail = event.wheelDelta || event.detail
      let moveForwardStep = -1
      let moveBackStep = 1
      let step = 0
      step = detail > 0 ? moveForwardStep * 100 : moveBackStep * 100
      event.preventDefault() // 阻止浏览器默认事件
      this['domObj' + type].scrollLeft = this['domObj' + type].scrollLeft + step
    }
  },
  created() {
    this.getImageBlob(this.$store.state.static_img_url + 'pic/logo_whrite.png', (url) => {
      this.logo_whrite = url
    })
    this.getImageBlob(this.$store.state.static_img_url + 'pic/logo.png', (url) => {
      this.logo_path = url
    })
  },
  mounted() {
    if(this.node_form_list.filter(item => item.node_form_id == '1').length > 0){
      this.nodeFormId = '1'
      this.params.node_form_id = '1'
    }else{
      this.nodeFormId = this.node_form_list[0].node_form_id
      this.params.node_form_id = this.node_form_list[0].node_form_id
    }
    this.scrollFunction('')
    this.scrollFunction('modal')
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/constrast.stylus'
.pipeline-cursor
  position relative
  &-div
    display flex
    justify-content space-between
    .pipeline-cursor-title
      font-size 16px
      font-weight 600
      commonColor(#ffffff, #333333)
      margin-bottom 10px
      line-height 22px
      width 600px
      i
        color #FC9C7C
        margin-right 15px
  &-more
    border 1px solid #FA5A00
    padding 0 8px
    height 22px
    font-size 12px
    font-weight 500
    color #fff
    background #FA5A00
    line-height 22px
    cursor pointer
    text-align center
    width 110px
    i
      color #fff
      font-size 12px
      margin-left 5px
    &:hover
      commonBgColor(#1f2330, #fff)
      border 1px solid #FA5A00
      color #FA5A00
      i
        color #FA5A00
  &-summary
    commonColor(#BCBDC1, #666666)
    font-size 14px
    line-height 22px
    margin-top -3px
    margin-bottom 7px
  &-filter
    display flex
    justify-content space-between
    margin-bottom 24px
    padding-top 20px
    .upload-img
      width 92px
      height 36px
      background #FA5A00
      color #FFFFFF
      font-size 13px
      display flex
      justify-content center
      align-items center
      cursor pointer
      transition all 0.2s
      position relative
      &.upload-img-false
        background #FFB476 !important
      &:hover
        background #F78127
      .upload-loading
        display flex
        justify-content center
        align-items center
        i
          margin-right 4px
    .ivu-dropdown
      margin-right 10px
      margin-bottom 10px
      line-height 1
      font-size 0
      font-weight normal
      .btn
        display inline-block
        height 36px
        commonBgColor(#2A2F42, #FFFFFF)
        border 1px solid
        commonBorderColor(#2A2F42, #E9E9E9)
        padding 0 15px
        display flex
        justify-content center
        align-items center
        cursor pointer
        span
          font-size 12px
          line-height 18px
          display inline-block
          commonColor(#E9E9EB, #666666)
          vertical-align top
        .ivu-icon
          font-size 18px
          color rgba(250, 122, 80, 1)
          vertical-align top
          margin-left 4px
    >>> .ivu-select-dropdown
      commonBgColor(#2D2F34, #fff)
      commonShadow(0 4px 20px 0 rgba(0, 0, 0, 0.5), 2px 4px 20px 0px rgba(121, 133, 143, 0.2))
      border-radius 0
      .ivu-dropdown-menu
        max-height: 210px
        overflow: auto
        .ivu-dropdown-item
          commonColor(rgba(255, 255, 255, 0.9), #666)
        .ivu-dropdown-item-selected, .ivu-dropdown-item.ivu-dropdown-item-selected:hover
          color rgba(250, 122, 80, 1) !important
          commonBgColor(#35383F, #f9f9f9)
        .ivu-dropdown-item-selected, .ivu-dropdown-item-selected:hover
          color rgba(250, 122, 80, 1) !important
        .ivu-dropdown-item:hover
          commonBgColor(#35383F, #f9f9f9)
  &-div
    width 700px
    overflow auto
    &::-webkit-scrollbar-thumb
      background-color #FA5A00
    &::-webkit-scrollbar-track
      commonBgColor(#323646, #fff)
    &::-webkit-scrollbar-corner
      commonBgColor(#323646, #fff)
  .tip-content
    display flex
    justify-content space-between
    align-items center
    .tip
      font-size 12px
      commonColor(#BCBDC1, #999999)
      margin-top 10px
  .upload-div
    position absolute
    width 0
    height 0
    overflow hidden
    > div
      width max-content
      commonBgColor(rgba(24, 26, 35, 1), rgba(255, 255, 255, 1))
      position relative
      display: inline-block
      > img
        position absolute
        width 112px
        right 40px
        top 60px
      .pipeline-cursor-title
        margin 54px 30px 10px
      .pipeline-cursor-summary
        margin-bottom 40px
        max-width 900px
        padding-left 31px
        margin 0 30px 40px
      >>> .pip-table
        margin 30px 30px 54px
.all-modal
  >>>.ivu-modal-wrap
    display flex
    .ivu-modal
      display flex
      justify-content center
      align-items center
      max-width 98vw
      top auto
      .ivu-modal-content
        max-width 98vw
        max-height 80vh
        commonBgColor(#181A23, #fff)
        .ivu-modal-close
          top 25px
        .ivu-modal-header
          border-bottom 0
          padding 0 20px 0
        .ivu-modal-body
          padding 0
          margin-top -15px
  .pipeline-content
    padding 0 20px 20px
  .pipeline-cursor-content-right
    border-right 1px solid 
    commonBorderColor(#515a6e, #e9e9e9)
    commonBgColor(#2a2f42, #fffaf5)
    // background #fffaf5
    .pipeline-cursor-filter
      padding-top 0
      margin-bottom 10px
    table
      border 1px solid
      border-bottom 0
      border-right 0
      table-layout fixed
      display block
      max-height 70vh
      commonBorderColor(#515a6e, #E9E9E9)
      commonBgColor(rgba(50, 54, 70, 1), rgba(255, 255, 255, 1))
      // commonBgImg('~pic/watermark-white.png', '~pic/watermark-gray.png')
      td
        height 60px
        commonColor(rgba(233, 233, 235, 1), rgba(51, 51, 51, 1))
        &.left-th
          padding 0 8px
          &:first-of-type
            padding-left 20px
          &+.right-th
            border-left 1px solid
            commonBorderColor(#515a6e, #E9E9E9)
        &.right-th
          text-align center
        a
          color #FA5A00
          &:hover
            color #FFA050
      thead
        td
          commonBgColor(rgba(42, 47, 66, 1), rgba(255, 250, 245, 1))

</style>